import React from "react";

import { CreateOrderProvider } from "./common/provider/CreateOrderProvider";
import { CreateOrderForm } from "./CreateOrderForm";

export const CreateOrderPage: React.FC = () => {
    return (
        <CreateOrderProvider>
            <CreateOrderForm />
        </CreateOrderProvider>
    );
};
